import React from 'react';
import { MAXIMUM_AMOUNT_OF_EXPOSURE_TAG_VIEW_AMOUNT } from '../../../../../constants/service/app/tagConstants';
import { setMaximumText } from '../../../../../lib/common';
import './TagPreviewItemHeader.scss';

const TagPreviewItemHeader = (props) => {
  const { tagName, tagViewInfo, isFollowingButton = true } = props;

  return (
    <div className="tag-preview-item-header">
      <div className="tag-info">
        <div className="tag-name">#{tagName}</div>
        <div className="tag-news-and-views">
          <span>{setMaximumText(tagViewInfo.viewCnt, MAXIMUM_AMOUNT_OF_EXPOSURE_TAG_VIEW_AMOUNT)} 소식</span>
          <div className="dot" />
          <span>{setMaximumText(tagViewInfo.newsCnt, MAXIMUM_AMOUNT_OF_EXPOSURE_TAG_VIEW_AMOUNT)} 조회</span>
        </div>
      </div>

      {isFollowingButton ? <div className="following-button">팔로잉</div> : null}
    </div>
  );
};

export default TagPreviewItemHeader;
